import React from 'react';

import delv from 'dlv';
import { useIntl } from 'react-intl';

import Picture from 'components/picture';
import { useCustomizableContent } from 'state/customizable-content';

import { ImageContainer, RewardPoints, RewardsTitleContainer } from './styled';

const ScanRewardsHeader: React.FC<{ points?: number }> = ({ points = 0 }) => {
  const { formatMessage } = useIntl();
  const { loyaltyContent } = useCustomizableContent();

  const timsRewardsImage = delv(loyaltyContent, 'timsRewardsImage.locale');
  return (
    <RewardsTitleContainer tabIndex={0}>
      <ImageContainer>
        <Picture
          data-testid="tim-rewards-logo"
          image={timsRewardsImage}
          alt={formatMessage({ id: 'timsRewards' })}
          objectFitContain
        />
      </ImageContainer>
      <RewardPoints data-testid="tim-rewards-loyalty">
        {formatMessage({ id: 'loyaltyDropdownPoints' }, { points })}
      </RewardPoints>
    </RewardsTitleContainer>
  );
};

export default ScanRewardsHeader;
